<script lang="ts">
      import { onMount } from 'svelte'
      import { createPageStateContext } from './ts/PageStateContext.svelte'

      const pageState = createPageStateContext()


      onMount( () => {
        
        window._pageState = pageState
      })

      $effect( () => {
      })

      let { children = undefined } = $props()
</script>

{@render children?.()}
